import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { QueueEffects } from './+state/queue.effects';
import * as fromQueue from './+state/queue.reducer';

const SERVICES = [
];

const MODULES = [
  CommonModule,
];

const STATE_MODULES = [
  StoreModule.forFeature(fromQueue.queuesFeatureKey, fromQueue.reducer),
  EffectsModule.forFeature([QueueEffects]),
];

@NgModule({
  imports: [MODULES, STATE_MODULES],
  providers: [SERVICES]
})
export class StateQueueModule { }
